import React, {useEffect, useState} from 'react';
import cloneDeep from 'lodash/cloneDeep';
import {StorageObject} from '../../../models/StorageObject';
import {FileMetaDataDialog} from './FileMetaDataDialog';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {EditFileDialogProps} from '../StorageObjectDialogProps';

export const EditFileDialog: React.VFC<EditFileDialogProps> = (props) => {
    const [editedItem, setEditedItem] = useState<StorageObject | null>(props.item ? cloneDeep(props.item) : null);

    useEffect(() => {
        if (props.item) {
            setEditedItem(cloneDeep(props.item));
        } else {
            setEditedItem(null);
        }
    }, [props.item]);

    const renderDialog = () => {
        return (
            <FileMetaDataDialog item={editedItem}
                                name={editedItem?.name ?? ''}
                                breadcrumbs={props.breadcrumbs}
                                currentPath={props.currentPath}
                                parentOwnerRoles={props.parentOwnerRoles}
                                parentRoles={props.parentRoles}
                                parentLocales={props.parentLocales}
                                language={props.language}
                                defaultLocale={props.defaultLocale}
                                disclaimerData={props.disclaimerData}
                                labelData={props.labelData}
                                rolesDataSource={props.rolesDataSource}
                                onClose={props.onClose}
                                onSave={props.onSave}/>
        );
    };

    return <div id={generateIdentifier()}>{renderDialog()}</div>;
};
